import glam from 'glamorous';
import React from 'react';
import { createPureComponent } from 'module/Common';
import { Logo } from '../Logo';
import { NavProvider } from '../NavProvider';
import { RouteType } from 'module/Model/Routes';

type LogoLinkProps = {
  centered?: boolean;
  size?: number;
  padding?: boolean;
  onClick?: () => void;
};

const LogoLinkWrapper = glam.a({
  display: 'block',
  cursor: 'pointer',
  textDecoration: 'none',
  ':hover': {
    textDecoration: 'none',
  },
});

export const LogoLink = createPureComponent<LogoLinkProps>('LogoLink', ({ onClick, ...logoProps }) => (
  <NavProvider routeType={RouteType.Home} search="" requestNavigation={true}>
    {params => (
      <LogoLinkWrapper
        {...params.getAnchorProps({
          onClick: onClick,
        })}
      >
        <Logo {...logoProps} />
      </LogoLinkWrapper>
    )}
  </NavProvider>
));



// WEBPACK FOOTER //
// ./src/module/View/Common/component/LogoLink/index.tsx